import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { getProductPropsSelections } from 'components/product-detail/utils';
import { useMenuCalories } from 'hooks/menu/use-menu-calories';
import usePosVendor from 'hooks/menu/use-pos-vendor';
import usePricingFunction from 'state/menu-options/hooks/use-pricing-function';
import { UserSelectionModifierSlotMap } from 'state/product-wizard/types';
import { useUIContext } from 'state/ui';

export const useProductPropsSelections = () => {
  const { vendor } = usePosVendor();
  const { priceForItemOptionModifier } = usePricingFunction({ vendor });
  const { formatCurrencyForLocale } = useUIContext();

  const { formatMessage } = useIntl();
  const { formatCalories } = useMenuCalories();

  const buildProductPropsSelections = useCallback(
    (modifierSelections: UserSelectionModifierSlotMap) =>
      getProductPropsSelections({
        formatCalories,
        formatCurrencyForLocale,
        formatMessage,
        modifierSelections,
        priceForItemOptionModifier,
      }),
    [formatCalories, formatCurrencyForLocale, formatMessage, priceForItemOptionModifier]
  );

  return {
    buildProductPropsSelections,
  };
};
